module.exports = __webpack_public_path__ + "static/assets/72fcd53a88e691fb2a2c9b9013b61259.png";